import React from "react";
import {connect} from 'react-redux'
import {Link} from "react-router-dom";
import {max} from 'lodash'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

//Icons
import CallSplit from "@material-ui/icons/CallSplit";
import AddIcon from "@material-ui/icons/Add";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
//import Settings from '@material-ui/icons/SettingsSharp';

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

// core components
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

//import Button from "components/CustomButtons/Button.jsx";
import Table from "components/Table/Table.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Checkbox from "components/Checkbox/Checkbox";

import FileCopy from "@material-ui/icons/FileCopy";
//Table actions
import Actions from 'views/Tables/Actions'

//Approve popUp
import ConfirmAlert from 'components/Alert/Confirm'
import ProgressAlert from 'components/Alert/Progress'
import SuccessAlert from 'components/Alert/Success'

//Styles
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import {PROFILES_TYPES} from 'constants/profiles'
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";

import DefaultProfileModal from './DefaultProfileModal'
// Actions
import {
  profileFilter,
  profilesFetch,
  profilesFetchFilter,
  profileRemove,
  profileFetch,
  profileSave,
  profilesFetchAllHelper
} from 'actions/profiles'

import {
  profileSpecialCaseSave,
  profileSpecialCasesFetch,
} from 'actions/profileSpecialCases'

import {
  danger,
} from 'actions/notification'

const customStyle = {
  baseProfile: {
    display: 'inline-block',
    padding: '5px 10px',
    borderRadius: '15px',
    color: 'white',
    background: '#00acc1',
    textAlign: 'center',
    maxWidth: '150px',
    marginRight: '5px'
  },
  defaultProfile: {
    display: 'inline-block',
    padding: '5px 10px',
    borderRadius: '15px',
    color: 'white',
    background: '#5d6168',
    textAlign: 'center',
    maxWidth: '150px',
    marginRight: '5px'
  }
}

class List extends React.Component {
  selected=[]
  state = {
    selected: [],
    remoteFilters:{
      name: ''
    },
    selectedProfileType: 0,
    allDefaultProfiles: [],
    openModal: false
  }
  componentDidMount(){
    this.props.filter({size: 10})
    this.props.fetch()
    this.props.profilesFetchAll({filter: true}).then((res) => {
      this.setState({allDefaultProfiles: res})
    })
  }
  //on choose record
  select(id) {
    let select = []
    if (Array.isArray(id)) 
      select = (this.state.selected.length > 0)
        ? []
        : id
    else if (this.state.selected.indexOf(id) > -1) 
      select = this.state.selected.filter((e) => e !== id)
    else 
      select = this
        .state
        .selected
        .concat(id)
    this.setState({
      ...this.state,
      selected: select
    })
  }
  confirmDelete() {
      if(this.selected.length===0){
        let filter = this.state.selectedProfileType !== 0 
          ? this.state.selectedProfileType === 'DEFAULT' ? true : false
          : null 
        this.props.fetch({filter: filter})
        this.props.profilesFetchAll({filter: true}).then((res) => {
          this.setState({
            ...this.state,
            selected:[],
            alert: <SuccessAlert
              title={`Done!`}
              onConfirm={()=>{this.setState({...this.state,alert:false});}}
            />,
            allDefaultProfiles: res
          })
        })
        
        return false;
      }
      this.setState({
        ...this.state,
        alert: <ProgressAlert
        value={100-((this.selected.length*100)/this.state.selected.length)}
        title={`Delete Profiles (${this.state.selected.length-this.selected.length+'/'+this.state.selected.length})`}
        />
      });
      this.props.remove(this.selected[0])
        .then((e)=>{
          this.selected=this.selected.slice(1);
          this.confirmDelete();
        }).catch((e) => {
          this.props.danger(e+'',4)
          this.setState({...this.state,alert:false})
        })
  }
  //on choose click delete 
  delete() {
    this.setState({
      ...this.state,
      alert: <ConfirmAlert
        text={`to delete ${this.state.selected.length} profiles \n( ${
          this.state.selected.map(id=>this.props.profiles.list.find(e=>e.profileId===id).name).join(', ')
        } )`}
        onCancel={()=>this.setState({...this.state,alert:false})}
        onConfirm={()=>{
          this.selected=this.state.selected.slice(0);
          this.confirmDelete();
      }}
      />
    });
  }
  //Filter change for pagination or limitation
  filter(filter){
    this.setState({...this.state,selected:[]})
    this.props.filter({
      ...this.props.profiles.pageable,
      ...filter,
      page: filter.size 
        ? 0 
        : filter.page !== undefined ? filter.page : this.props.profiles.pageable.page
    })
    let datafilter = this.state.selectedProfileType !== 0
      ? this.state.selectedProfileType === 'DEFAULT' ? true : false
      : null 
    this.props.fetch({filter: datafilter})
  }
  openModal(){
    this.setState({openModal: true})
  }
  profileTypeChange(e){
    this.setState({selectedProfileType: e.target.value})
    let filter = e.target.value !== 0
      ? e.target.value === 'DEFAULT' ? true : false
      : null 
    this.props.fetch({filter: filter})
  }
  filterSelect() {
    const {classes} = this.props
    let {selectedProfileType} = this.state
    const profileTypes = [
      {value: 'DEFAULT', label:'Default Profiles'},
      {value: 'BASIC', label: 'Based on Default'}
    ]
    return <GridContainer >
      <GridItem xs={11} sm={6}>
        {
        <FormControl
          fullWidth
          className={classes.selectFormControl}
        >
          <InputLabel htmlFor="selectedProfileType" className={classes.selectLabel} >
            Profile
          </InputLabel>
          <Select
            value={selectedProfileType}
            MenuProps={{
              className: classes.selectMenu
            }}
            classes={{
              select: classes.select
            }}
            inputProps={{
              onChange: this.profileTypeChange.bind(this),
              id: "selectedProfileType",
              name: "selectedProfileType"
            }}>
              <MenuItem
                key={0}
                classes={{
                  root: classes.selectMenuItem
                }}
                value={0}
              >
                {'All'}
              </MenuItem>
            {profileTypes
              .map((e) => (
                <MenuItem
                  key={e.value}
                  classes={{
                    root: classes.selectMenuItem
                  }}
                  value={e.value}>
                  {e.label}
                </MenuItem>
              ))}
          </Select>

        </FormControl>
        }
      </GridItem>
      
    </GridContainer>
  }
  getNewProfileName(profile, abbr){

    let dublicateProfileNames = this.state.allDefaultProfiles
      .filter((p) => p.name.includes(`${profile.name}${abbr}`))
    if(dublicateProfileNames.length === 0){
      return `${profile.name}${abbr}${1}`
    } else{
      //find max profilename number
      let dublicates = dublicateProfileNames.map((p) => Number(p.name.replace(`${profile.name}${abbr}`, '')))
      let maxDublicate = max(dublicates)
      return `${profile.name}${abbr}${maxDublicate + 1}`
    }
  }
  copyProfile(){
    const selected = this.state.selected
    this.props.profileFetch(selected[0]).then((prof) => {
      let newProfile = {...prof}
      newProfile.name = this.getNewProfileName(prof, '_copy_')
      delete newProfile.profileId
      delete newProfile.externalId
      this.props.profileSave(newProfile).then((newdbProf) => {
        //save special cases
        this.props.profileSpecialCasesFetch(selected[0]).then((cases) => {
          cases.forEach((specialcase) => {
            let newCase = {...specialcase}
            delete newCase.profileSpecialCaseId
            newCase.symbols = newCase.symbols.map((x) => x.symbolId)
            this.props.profileSpecialCaseSave(newdbProf.profileId, newCase)
          })
          this.props.fetch()
          this.props.profilesFetchAll({filter: true}).then((res) => {
            this.setState({allDefaultProfiles: res})
          })
        })

      })
    })

  }
  
  fetchRemoteFilter(value, key){
    
    this.setState({
      ...this.state,
      remoteFilters: {
        ...this.state.remoteFilters,
        [key]: value
      }
    })

    this.props.fetchFiltered(value,false)

  }

  render() {
    const {match, profiles, classes} = this.props;
    const selected = this.state.selected
    const filterColumns = [
      {
        name: 'name',
        filterChangeAction: (value, key) => this.fetchRemoteFilter(value, key),
        value: this.state.remoteFilters.name
      }
    ]

    return (
      <Card>
        {this.state.alert}
        {
        (!profiles.isFetching)?
        //Top actions (pgination/limit/add/remove/edit)
        <Actions
          onPagination={(page)=>this.filter({page:page-1})}
          limit={profiles.pageable.size}
          limitOptions={[10,100,200]}
          onLimitation={(page)=>this.filter({size:page})}
          pagination={profiles.pageable.totalPages>1?{
            pages:profiles.pageable.totalPages,
            current:profiles.pageable.page+1,
          }:false}
          title={this.filterSelect()}
          dark={selected.length>0}
          icon={<CallSplit/>}
          actions={{
            add: (selected.length===0)
            ? <span onClick={() => this.openModal()}>
              <IconButton>
                <AddIcon/>
              </IconButton>
            </span>
            : '',
            delete: (selected.length>0) && this.props.permissions.includes('PROFILES_DELETE')
              ? <IconButton onClick={this.delete.bind(this)}><DeleteIcon/></IconButton>
              : '',
            edit: (selected.length===1)
              ? <Link to={`${match.path}/${this.state.selected[0]}`}>
                  <IconButton>
                      <EditIcon/>
                  </IconButton>
                </Link>
              : '',
            copy: (selected.length === 1)
              ? <IconButton>
                  <FileCopy onClick={() => this.copyProfile()} />
              </IconButton>
              : '',
        }}/>:''}

        <CardBody>
          {/* If is fetching not display table*/}
          {(profiles.isFetching)
            ? <LinearProgress color="primary"/>
            : (
              //Main table
              <Table
                tableHeaderColor="primary"
                sort={profiles.pageable.sort}
                onSort={(e)=>this.filter({sort:{[e]:profiles.pageable.sort[e]==='desc'?'asc':'desc'}}) }
                filterColumns={filterColumns}
                tableHead={{ 
                    checkbox:<Checkbox props = {{ 
                      onClick:()=>this.select(profiles.list.map(e=>e.profileId)),
                      checked:this.state.selected.length===profiles.list.length}
                    }/>,
                    profileId:"#", 
                    name:"Name", 
                    markup:"Markup Rebate", 
                    commission:"Commission Rebate",
                    mrPerType:"Markup Per Type", 
                    crPerType:"Сommission Per Type",
                    baseProfile: "Tag"
                    //cases:"Special Case", 
                  }}
                tableData={profiles.list.map((e,i) => {
                  let isBasedOnDefault = profiles.list.find((x) => x.profileId === e.baseProfile)
                  let isDefault = e.defaultProfile
                  let tags = [
                    isBasedOnDefault ? <div key={i+'_1'} className={classes.baseProfile}>{`Based on Default ${isBasedOnDefault.name}`}</div> : '',
                    isDefault ? <div key={i+'_2'} className={classes.defaultProfile}>Default</div> : ''
                  ]
                  return [ 
                    <Checkbox props = {{ onClick:()=>this.select(e.profileId), checked:this.state.selected.indexOf(e.profileId)>-1 }}/>,
                    e.profileId, 
                    e.name, 
                    e.markup, 
                    e.commission, 
                    PROFILES_TYPES[e.mrPerType], 
                    PROFILES_TYPES[e.crPerType],
                    <div className={'profile-table-tags'}>{tags.map((t)=> (t))}</div>
                  ]
                })}/>
                  
            )}
            {this.state.openModal && (
              <DefaultProfileModal
                profiles={this.state.allDefaultProfiles}
                close={() => this.setState({openModal: false})}
                save={(profileType, defaultProfile) => {

                  if(profileType === 'NEW'){
                    this.props.history.push(`/administration/profiles/add`)
                  } else if(profileType === 'DEFAULT'){
                    this.props.history.push(`/administration/profiles/addDefault`)
                  } else if(profileType === 'BASED' && defaultProfile){
                    this.props.profileFetch(defaultProfile).then((prof) => {
                      let newProfile = {...prof}
                      newProfile.name = this.getNewProfileName(prof, '_based_')
                      newProfile.baseProfile = defaultProfile
                      delete newProfile.profileId
                      newProfile.defaultProfile = false
                      this.props.profileSave(newProfile).then((newdbProf) => {
                        //select all special casese from prof
                        this.props.profileSpecialCasesFetch(defaultProfile).then((cases) => {
                          cases.forEach((specialcase) => {
                            let newCase = {...specialcase}
                            delete newCase.profileSpecialCaseId
                            newCase.symbols = newCase.symbols.map((x) => x.symbolId)
                            this.props.profileSpecialCaseSave(newdbProf.profileId, newCase)
                          })
                          this.props.history.push(`/administration/profiles/${newdbProf.profileId}`)
                        })

                        this.props.profilesFetchAll({filter: true}).then((res) => {
                          this.setState({allDefaultProfiles: res})
                        })
                      })
                    })
                  }
                  this.setState({openModal: false})
                  //this.props.history.push(`/administration/profiles/${id}`)
                }}
              />)}
        </CardBody>
       { 
         profiles.list.length>20
        ?<Actions
            onPagination={(page)=>this.filter({page:page-1})}
            pagination={profiles.pageable.totalPages>1?{
              pages:profiles.pageable.totalPages,
              current:profiles.pageable.page+1,
            }:false}
        />:''}
      </Card>
    );
  }
}
const mapStateToProps = (state) => ({
  profiles: state.profiles,
  permissions: state.auth.permissions
})
const mapDispatchToProps = (dispatch) => ({
  filter: (filter) => dispatch(profileFilter(filter)),
  fetch: (data) => dispatch(profilesFetch(data)),
  fetchFiltered: (profileName,loading) => dispatch(profilesFetchFilter(profileName,loading)),
  remove: (id) => dispatch(profileRemove(id)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  profileFetch:(id)=>dispatch(profileFetch(id)),
  profileSave:(data)=>dispatch(profileSave(data)),
  profilesFetchAll: (data) => dispatch(profilesFetchAllHelper(data)),
  profileSpecialCasesFetch:(profileId)=>dispatch(profileSpecialCasesFetch(profileId)),
  profileSpecialCaseSave:(profileId, data)=>dispatch(profileSpecialCaseSave(profileId, data)),
})
export default withStyles({...buttonsStyle, ...selectStyles, ...customStyle})(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/views/Profiles/List.jsx